export default [
  {
    title: 'Основное',
    value: 'main'
  },
  {
    title: 'Виджеты',
    value: 'widgets'
  }
]
